import React, { useEffect, useState } from "react";
import { Card } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { Loader2, ShieldAlert, Calendar } from "lucide-react";
import { listLoginAttempts } from "../lib/api_extra";

export default function LoginAttempts() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    listLoginAttempts(500).then(setItems).finally(() => setLoading(false));
  }, []);

  return (
    <div className="space-y-4" data-testid="login-attempts-page">
      <div>
        <h1 className="text-3xl sm:text-4xl font-bold text-slate-900" style={{ fontFamily: "Outfit, sans-serif" }}>
          Tentativi di login falliti
        </h1>
        <p className="text-slate-500 text-sm mt-1">Audit di sicurezza — ultimi 500 tentativi PIN/Password falliti</p>
      </div>

      {loading ? (
        <Card className="p-8 text-center"><Loader2 size={28} className="mx-auto animate-spin text-[#1B5E20]" /></Card>
      ) : items.length === 0 ? (
        <Card className="p-8 text-center text-slate-500" data-testid="login-attempts-empty">
          <ShieldAlert size={36} className="mx-auto text-[#1B5E20] mb-2" />
          <div className="text-base font-semibold text-slate-700">Nessun tentativo fallito recente.</div>
          <div className="text-sm text-slate-400 mt-1">Lo storico include i tentativi automatic (rate limit 5/30min).</div>
        </Card>
      ) : (
        <div className="grid gap-1.5">
          {items.map((a) => (
            <Card key={a.id} className="p-3 border-slate-200" data-testid={`login-attempt-${a.id}`}>
              <div className="flex items-start justify-between gap-2 flex-wrap">
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="font-mono text-xs text-slate-700 truncate">{a.email}</span>
                    <Badge style={{
                      backgroundColor: a.tipo === "PIN" ? "#F57C00" : "#1565C0",
                      color: "#fff",
                    }} className="text-[10px]">{a.tipo}</Badge>
                  </div>
                  <div className="text-xs text-slate-500 mt-0.5 flex items-center gap-1">
                    <Calendar size={10} /> {new Date(a.timestamp).toLocaleString("it-IT")}
                  </div>
                </div>
                <div className="text-right text-[10px] text-slate-400 max-w-[40%] truncate">
                  {a.ipAddress || "-"}<br />
                  {(a.userAgent || "").substring(0, 40)}
                </div>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
